module.exports = __webpack_public_path__ + "img/passenger_icon.1d8d2303.jpg";